module.exports = __webpack_public_path__ + "img/img-logo-header.c66887fb.png";